export enum Page {
  home,
  trafficInfo,
  positionRequest,
  trainOnTimeAdmin,
  contacts,
  trainOrders,
  alcolock,
  driverDeviations
}

export enum PageName{
  "" = 0,
  "trafikinfo" = 1,
  "positionsforfragning" = 2,
  "tagitidadmin" = 3,
  "kontakter" = 4,
  "tagorder" = 5,
  "alcolock" = 6,
  "foraravvikelser" = 7
}
